// IMI, Kolkata Json
const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const universityBgImage = imageBaseUrl + "International-Relation/University/Imi-Kolkata.png";

const kolkata = imageBaseUrl + "International-Relation/University/kolkata.png";

const Fees_IMI_Kolkata_Africa = imageBaseUrl + "International-Relation/University/fee-structure/Fees_IMI Kolkata_Africa.pdf";
const Fees_IMI_Kolkata_Middle_East = imageBaseUrl + "International-Relation/University/fee-structure/Fees_IMI Kolkata_Middle East.pdf";
const Fees_IMI_Kolkata_SAARC = imageBaseUrl + "International-Relation/University/fee-structure/Fees_IMI Kolkata_SAARC.pdf";

const k1 = imageBaseUrl + "universityKnow/k1.png";
const k2 = imageBaseUrl + "universityKnow/k2.png";
const k3 = imageBaseUrl + "universityKnow/k3.png";
const k5 = imageBaseUrl + "universityKnow/k5.png";
const k6 = imageBaseUrl + "universityKnow/k6.png";


export const imiKolkataJson = {
  BannerData: {
    heading: "IMI, Kolkata",
    backgroundImage: universityBgImage,
    content: (
      <>
      International Management Institute (IMI) Kolkata, established in 2010, is a premier private business school located in Kolkata, India.
       It offers a two-year full-time Post Graduate Diploma in Management (PGDM), accredited by the National Board of Accreditation (NBA) and recognized as equivalent to an MBA by the Association of Indian Universities (AIU).
       In 2017, IMI Kolkata introduced the Fellow Programme in Management (FPM), a doctoral-level program.
        The institute has established international collaborations with renowned institutions such as ESC Rennes School of Business (France) and Sichuan University (China), promoting joint research and academic exchanges.
         Situated at 2/4C, Judges Court Road, Alipore, Kolkata, IMI Kolkata is committed to shaping global leaders for tomorrow.
      </>
    ),
  },

  // University Details
 

  universityDetails: [
    {
      id: 1,
      title: "Name",
      subtitle: "International Management Institute (IMI) Kolkata",
      image: imageBaseUrl + "universityinfo/1.png",
    },
    {
      id: 2,
      title: "Location",
      subtitle: " Kolkata, West Bengal, India",
      image: imageBaseUrl + "universityinfo/2.png",
    },
    {
      id: 3,
      title: "Founded",
      subtitle:
        "2010",
        image: imageBaseUrl + "universityinfo/3.png",
    },
    {
      id: 4,
      title: "Type",
      subtitle: "Private Business School",
      image: imageBaseUrl + "universityinfo/4.png",
    },
    {
      id: 5,
      title: "Total Enrollment",
      subtitle: "326 students (2023)",
      image: imageBaseUrl + "universityinfo/5.png",
    },
    {
      id: 6,
      title: "International Students",
      subtitle: " From at least 9 different countries",
      image: imageBaseUrl + "universityinfo/6.png",
    },
    {
      id: 7,
      title: "Website",
      subtitle: "Strengthening international recognition and credibility",
      image: imageBaseUrl + "universityinfo/7.png",
      url: "https://imik.edu.in/",
    },
  ],
  
  

  WhyChooseThisUniversityPage:[
    { id: 1, rank: "56th", title:(<><b>56th Rank - </b> NIRF 2024 (Management Institutes in India)</>) },
    { id: 2, rank: "15th", title:(<>Ranked <b>15th</b> among private MBA institutions in India by <b>Outlook ICARE Business School Ranking 2022</b></>) },
    { id: 3, rank: "1 NBA", title: (<><b>1 NBA-Accredited PGDM - </b>Recognized as an MBA equivalent by AIU</>) },
  ],

  feeStructure: [
    { label: "Africa", value: "Africa", pdfFile: Fees_IMI_Kolkata_Africa },
    { label: "Middle East", value: "Middle East", pdfFile: Fees_IMI_Kolkata_Middle_East},
    { label: "SAARC", value: "Middle East", pdfFile: Fees_IMI_Kolkata_SAARC},
  ],

KnowMore:[
  {
    title: "Campus Life",
    img: k1, 
    url: "https://imik.edu.in/campus-life/",
  },
  {
    title: "How to Apply",
    img: k2, 
    url: "https://admission.imi.edu/kolkata/",
  },
  {
    title: "International Students",
    img: k3, 
    url: "https://imik.edu.in/programmes/international-student-exchange-program-isep/",
  },

  {
    title: "Accommodation",
    img: k5, 
    url: "https://imik.edu.in/imi-infrastructure/hostel/",
  },
   
  {
    title: "Brochure",
    img: k6, 
    url: "https://blog.westawk.com/wp-content/uploads/2023/01/IMI-Kolkata-brochure-2023.pdf",
  },
],

Location:{
    header:"KOLKATA",
    image: kolkata,
    content: (<>Kolkata boasts a prestigious academic heritage, abundant career opportunities, and a lively cultural scene, making it an ideal choice for international students.
    <br></br>
    <br></br>
      <ul style={{"margin-left": "20px"}}>
        <li><b>Renowned Institutions</b></li>
        <li><b>Booming Career Opportunities</b></li>
      <li><b>Cultural & Literary Hub</b></li>
      <li><b>Excellent Connectivity</b></li>
      <li><b>Safe & Affordable</b></li>
      </ul>
      </>) },

    
};